import { useState } from "react";
import { useRegisterSW } from "virtual:pwa-register/react";
import { PwaUpdateBanner } from "@cliqsuite/ui";

const alwaysIdle = () => true;

export function UpdateBanner() {
  const [registration, setRegistration] = useState<ServiceWorkerRegistration | null>(null);
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({ onRegisteredSW: (_url, value) => setRegistration(value ?? null) });

  return (
    <PwaUpdateBanner
      needRefresh={needRefresh}
      setNeedRefresh={setNeedRefresh}
      updateServiceWorker={updateServiceWorker}
      registration={registration}
      message="A new version is ready — updating now."
      isIdle={alwaysIdle}
      allowDismiss={false}
    />
  );
}
